;jQuery(function ($) {

    const config = ( window.Testlab || {} ).config;

    if ( config && config.cookieBar ) {
        $.cookieBar( config.cookieBar );
    }

});